import * as React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import styles from './custom-spinner.module.sass';
import { useEffect } from 'react';

export interface ISpinnerProps {
    spinnerText: string,
    className?: string
    position?: 'absolute' | 'relative'
    textColor?: string
}

export const CustomSpinner = (props: ISpinnerProps) => {

    const [render, setRender] = React.useState<boolean>(false);

    useEffect(() => {
        setTimeout(() => {
            setRender(true);
        }, 500);
    }, []);

    if (render)
        return (

            <div
                className={`${props.position === 'relative' ? styles.relativeSpinner : styles.absoluteSpinner} text-center mt-5 ${props.className ?? ''}`}>
                <Spinner animation="border" role="status"><span className="visually-hidden">Loading...</span></Spinner>
                <div className="mt-3 spinner-text">
                    <strong className={props.textColor ? props.textColor : ''}>{props.spinnerText}</strong>
                </div>
            </div>
        );
};
